// klasse zum nachladen von JS scripten (inline + files)
export class ScriptDispatcher {

    constructor() {}

    // Methode zum Verarbeiten von Skript-Dateien basierend auf deren `src` - hier werden files neu geladen
    public dispatchScriptFiles(data: string): void {
        const tempElement = document.createElement('div');
        tempElement.innerHTML = data;
        const scriptTags = tempElement.querySelectorAll('script');

        if (scriptTags.length > 0) {
            scriptTags.forEach((scriptTag) => {
                const src = scriptTag.src;
                if (!src) {
                    return;
                }

                const newScript = document.createElement('script');
                newScript.type = 'text/javascript';
                newScript.src = src;

                document.body.appendChild(newScript);
            });
        }
    }

    // Methode zum Verarbeiten von Inline-Skripten
    public dispatchScriptTag(data: string): void {
        const tempElement = document.createElement('div');
        tempElement.innerHTML = data;
        const scriptTags = tempElement.querySelectorAll('script');

        if (scriptTags.length > 0) {
            scriptTags.forEach((scriptTag) => {
                const script = scriptTag.textContent;
                if (!script) {
                    return;
                }

                // ritch snippet script tags should not be executed
                if(scriptTag.getAttribute('type') === 'application/ld+json') {
                    return;
                }

                const newScript = document.createElement('script');
                [...scriptTag.attributes].forEach(attr => newScript.setAttribute(attr.name, attr.value));
                newScript.textContent = script;

                document.body.appendChild(newScript);
            });
        }
    }
}

// Export fuer globales window object
if (typeof window !== 'undefined') {
    (window as any)['ScriptDispatcher'] = ScriptDispatcher;
}
